import { ImageIcon } from 'lucide-react';
import React, { useState } from 'react';

interface ImageWithFallbackProps {
  src?: string;
  alt?: string;
  fallback?: React.ReactNode;
  className?: string;
}

const DefaultFallback: React.FC = () => (
  <div className="flex size-full items-center justify-center rounded-2xl bg-gray-100 text-gray-400">
    <ImageIcon className="h-6 w-6" />
  </div>
);

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  alt = 'Image',
  fallback,
  className = 'size-full object-contain'
}) => {
  const [error, setError] = useState(false);

  return error || !src ? (
    <>{fallback ?? <DefaultFallback />}</>
  ) : (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setError(true)}
    />
  );
};

export default ImageWithFallback;
